import { SkaldValue } from "@skaldaura/devkit"
import { PExt } from "components/myTags/myTags"
import { useState } from "react"
import Popup from "reactjs-popup"
import { Colors } from "styles/colors"
import "./gammeProduits.scss"

export interface IPopulatedProduct {
   titre?: SkaldValue[]
   image?: SkaldValue[]
   détail_produit?: SkaldValue[],
}

interface IProps {
   produit: IPopulatedProduct
   video?: string
}

export default function Produit({ produit, video }: IProps) {
   const [open, setOpen] = useState<boolean>(false)

   const closeModal = () => setOpen(false)
   const openModal = () => setOpen(true)

   return (
      <Popup
         trigger={
            <div className='product flex column'>
               <div className="product-picture">
                  <img src={produit.image ? produit.image[0].value : ""} />
                  {produit.image && produit.image[1] && <img src={produit.image[1].value} />}
                  <img src={`${process.env.PUBLIC_URL}`} alt='' className="touch-picto" />
               </div>
               <PExt center fontSize='13px' color={Colors.gris1}>
                  {produit.titre ? produit.titre[0].value.toUpperCase() : ""}
               </PExt>
            </div>
         }
         onOpen={openModal}
         onClose={closeModal}
         open={open}
         modal
         closeOnDocumentClick
      >
         <div className="product-popup" onClick={closeModal}>
            <div className="popup-content">
               <img src={produit.détail_produit ? produit.détail_produit[0].value : ""} className="object-contain" />
               {video && <video 
                  src={video} 
                  className="product-video" 
                  controls 
                  autoPlay 
                  muted 
                  loop />}
            </div>
         </div>
      </Popup>
   )
}